<template>

  <el-main class="main_content" style="padding: 0">
    <div class="cont_navs_header_board">
      <el-breadcrumb separator="/" class="bread">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>dashboard</a>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <a>控制台</a>
        </el-breadcrumb-item>
      </el-breadcrumb>
      <el-row class="clr">
        <el-col :span="14">
          <el-row>
            <el-col :span="3">
              <img style="width:72px;height:72px;" src="../assets/BiazfanxmamNRoxxVxka.png">
            </el-col>
            <el-col :span="21">
              <p style="font-size: 20px;line-height: 28px;font-weight: 500;color: rgba(0,0,0,.85);margin-bottom: 12px;">您好，管理员，祝你开心每一天！</p>
              <span style="color: rgba(0,0,0,.45);">煜美人系统管理控制台</span>
            </el-col>

          </el-row>
        </el-col>
        <el-col :span="10" class='nav_third'>
          <el-row>
            <el-col :span="4" class="nav_border">
              <p>
                订单数
              </p>
              <p class="num_nav">
                {{totalHouse}}
              </p>
            </el-col>
            <el-col :span="5" class="nav_border">
              <p>
                商品数
              </p>
              <p class="num_nav">

                <el-tooltip class="item" effect="dark" content="待上架商品数" placement="top">
                  <el-button type="text" style="color:black;font-size:30px;padding: 0;">{{totalActivity}}</el-button>
                </el-tooltip>

                <el-tooltip class="item" effect="dark" content="上架中商品数" placement="top">
                  <el-button type="text" style="font-size:20px;color:rgba(0,0,0,.45);padding: 0;margin:0px">/ {{totalInAc}}</el-button>
                </el-tooltip>
              </p>
            </el-col>
            <el-col :span="4" class="nav_border">
              <p>
                用户数
              </p>
              <p class="num_nav">
                {{totalPost}}
              </p>
            </el-col>
            <el-col :span="4" class="nav_border">
              <p>
                素材待审核
              </p>
              <p class="num_nav">
                {{waitJudge}}
              </p>
            </el-col>
            <el-col :span="4" class="nav_border">
              <p>
                投诉待处理
              </p>
              <p class="num_nav">
                {{waitComplain}}
              </p>
            </el-col>
          </el-row>
        </el-col>

      </el-row>
    </div>

    <div class="contain_div" v-loading="contain_loading">
      <el-row :gutter="10">
        <el-col :span="16">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>上架中的商品</span>
              <el-button v-show="hasPower('30011')" style="float: right; padding: 3px 0" type="text" @click="jumpTo('/goodList')">全部商品</el-button>
            </div>
            <div v-if="no_house" class="el-table__empty-block">
              <span class="el-table__empty-text">暂无数据</span>
            </div>
            <el-row :gutter="20">
              <el-col :span="6" :gutter="1" v-for="o in acList" :key="o.id" class="text card_body">

                <img :src="o.list_pic" class="image">
                <div style="padding: 14px;">
                  <span>{{o.good_name}}</span>
                  <div class="bottom clearfix">
                    <time class="time">{{ o.create_time }}</time>
                    <!-- <el-button type="text" class="button" @click="jumpTo('/up_house', '/house_list', o.id)">查看</el-button> -->
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>

          <el-card class="box-card" style="margin-top:20px" shadow="hover">
            <div slot="header" class="clearfix">
              <span>进行中的订单</span>
              <el-button v-show="hasPower('20041')" style="float: right; padding: 3px 0" type="text" @click="jumpTo('/orderList')">全部订单</el-button>
            </div>
            <el-row :gutter="20">
              <el-col :span="8" :gutter="1" v-for="o in houseList" :key="o.id" class="text card_body">
                <img :src="o.list_pic" class="image_ac">
                <div style="padding: 14px;">
                  <span>{{o.good_name}}</span>
                  <div class="bottom clearfix">
                    <time class="time">{{ o.create_time }}</time>
                    <el-button type="text" class="button">
                      <span v-if="o.status == 1">待支付</span>
                      <span v-if="o.status == 2">待发货</span>
                      <span v-if="o.status == 3">待收货</span>
                      <span v-if="o.status == 4">已完成</span>
                      <span v-if="o.status == 5">已取消</span>
                      <span v-if="o.status == 7">待自提</span>
                      <span v-if="o.status == 8">已自提</span>
                      <span v-if="o.status == 9">待补货</span>
                      <span v-if="o.status == 10">补货待支付</span>
                      <span v-if="o.status == 11">已补货</span>
                      <span v-if="o.status == 12">补货已过期</span>
                    </el-button>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-card>

        </el-col>
        <el-col :span="8">
          <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
              <span>快捷开始/便捷导航</span>
            </div>
            <div class="quick_a">
              <el-button v-show="hasPower('50011')" type="danger" plain @click="jumpTo('/money_in_list')">充值管理</el-button>
              <el-button v-show="hasPower('50021')" plain type="primary" @click="jumpTo('/money_out_list')">提现管理</el-button>
              <el-button v-show="hasPower('40031')" plain @click="jumpTo('/up_group_list')">代理审核</el-button>
              <el-button v-show="hasPower('20041')" plain type="success" style="margin-left:0px!important" @click="jumpTo('/orderList')">订单查看</el-button>
              <el-button v-show="hasPower('30011')" plain type="info" @click="jumpTo('/goodList')">商品管理</el-button>
              <el-button v-show="hasPower('20031')" plain type="warning" @click="jumpTo('/complainList')">投诉管理</el-button>
              <el-button v-show="hasPower('20021')" plain type="primary" @click="jumpTo('/judgeList')">素材管理</el-button>
              <!-- <a>添加房产</a>
              <a>添加活动</a>
              <a>房产列表</a>
              <a>添加文章</a>
              <a>审核帖子</a>
              <a>审核回复</a>
              <a>查看用户</a>
              <a>查看推荐</a>
              <a>查看轮播</a>
              <a>帮助中心</a> -->
            </div>

          </el-card>
          <el-card class="box-card" style="margin-top:20px" shadow="hover">
            <div slot="header" class="clearfix">
              <span>订单统计</span>
            </div>
            <!-- <div class="text item">
              <div class="inie-fia">
                <span>待支付订单数</span><span>{{orderPay}}笔</span>
              </div>
              <div class="inie">
                <span>待发货订单数</span><span>{{orderSend}}笔</span>
              </div>
              <div class="inie">
                <span>待收货订单数</span><span>{{orderCon}}笔</span>
              </div>
              <div class="inie">
                <span>已完成订单数</span><span>{{orderFini}}笔</span>
              </div>
              <div class="inie">
                <span>已取消订单数</span><span>{{orderCnac}}笔</span>
              </div>
              <div class="inie">
                <span>订单总金额</span><span>{{totalMoney}}元</span>
              </div>
            </div> -->

            <div class="echart" id="mychart" :style="myChartStyle"></div>
          </el-card>
        </el-col>

      </el-row>
    </div>
    <!-- 用户总数  帖子总数 房产总数
    快捷导航
    上架中的房产
    上架中的活动
    文章列表 -->

  </el-main>
</template>


<script>
import { bus } from "../bus.js";
import * as echarts from "echarts";
import API from "../api/api_user";
var _ = require("lodash");
export default {
  name: "Dashboard",
  data() {
    return {
      powers:[],
      orderPay:0,
      orderSend:0,
      orderCon:0,
      orderFini:0,
      orderCnac:0,
      no_house: false,
      currentDate: "2017-12-12",
      contain_loading: true,
      acList: [],
      houseList: [],
      sendNum:[],
      totalMoney:null,
      articleList: [],
      totalHouse: null,
      totalActivity: null,
      totalInAc: null,
      totalPost: null,
      waitComplain:null,
      waitJudge:null,
      xData: ["待支付订单数", "待发货订单数", "待收货订单数", "已完成订单数", "已取消订单数"], //横坐标
      yData: [], //数量
      myChartStyle: { float: "left", width: "100%", height: "400px" }
    };
  },
  mounted(e) {
    //初始化表单
    var that = this;
    //如果是区域负责人进不了这个页面
    var provinceList = localStorage.getItem("provinceList");
    if (provinceList && provinceList != '' && provinceList != null)
    {
      this.$router.push('/AreaDashboard');
      window.location.reload();
    }
    let powers = localStorage.getItem("powers");
    this.powers = JSON.parse(powers);
    var para = {
      token: localStorage.getItem("api_token")
    };
    that.contain_loading = false;
    API.dashboard(para)
      .then(
        function(result) {
          that.contain_loading = false;
          if (result.key == 1000) {
            that.acList = result.result.map.acList;
            that.houseList = result.result.map.houseList;

            that.totalMoney = result.result.map.totalMoney;
            that.waitComplain = result.result.map.waitComplain;
            that.waitJudge = result.result.map.waitJudge;
            that.sendNum = result.result.map.sendNum;

            that.orderPay = 0;
            that.orderSend = 0;
            that.orderCon = 0;
            that.orderFini = 0;
            that.orderCnac = 0;
            if (result.result.map.sendNum != null && result.result.map.sendNum.length > 0) {
              for (var i=0; i<result.result.map.sendNum.length; i++) {
                if (parseInt(result.result.map.sendNum[i].status) == 1 || parseInt(result.result.map.sendNum[i].status) == 10) {
                  that.orderPay = parseInt(result.result.map.sendNum[i].num);
                  that.yData.push(parseInt(result.result.map.sendNum[i].num));
                } else if (parseInt(result.result.map.sendNum[i].status) == 2) {
                  that.orderSend = parseInt(result.result.map.sendNum[i].num);
                   that.yData.push(parseInt(result.result.map.sendNum[i].num));
                } else if (parseInt(result.result.map.sendNum[i].status) == 3) {
                  that.orderCon = parseInt(result.result.map.sendNum[i].num);
                  that.yData.push(parseInt(result.result.map.sendNum[i].num));
                } else if (parseInt(result.result.map.sendNum[i].status) == 4) {
                  that.orderFini = parseInt(result.result.map.sendNum[i].num);
                  that.yData.push(parseInt(result.result.map.sendNum[i].num));
                } else if (parseInt(result.result.map.sendNum[i].status) == 5) {
                  that.orderCnac = parseInt(result.result.map.sendNum[i].num);
                  that.yData.push(parseInt(result.result.map.sendNum[i].num));
                }
              }
            }
            that.totalHouse = result.result.map.totalHouse;
            that.totalActivity = result.result.map.totalActivity;
            that.totalInAc = result.result.map.totalInAc;
            that.totalPost = result.result.map.totalPost;
            that.initEcharts();
          } else {
            that.$message.error({
              showClose: true,
              message: result.message || "登录失败",
              duration: 2000
            });
          }
        },
        function(err) {
          that.loading = false;
          that.$message.error({
            showClose: true,
            message: err.toString(),
            duration: 2000
          });
        }
      )
      .catch(function(error) {
        that.loading = false;
        console.log(error);
        that.$message.error({
          showClose: true,
          message: "请求出现异常",
          duration: 2000
        });
      });
      
  },
  methods: {

    hasPower(power) {
      var has = false;
      for (var i = 0; i < this.powers.length; i++) {
        if (this.powers[i] == power) {
          has = true;
          break;
        }
      }
      return has;
    },
    jumpTo(url, baseUrl, id) {
      bus.$emit('goto', url, baseUrl, {id:id})
      // this.defaultActiveIndex = url;
      // this.$router.push(url); //用go刷新
    },
    initEcharts() {
      const option = {
        xAxis: {
          axisLabel :{
          interval:0
          },
          data: this.xData
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: 300,
          interval: 50,

        },

        series: [{
            name: "订单数",
            type: "bar",
            data: this.yData,
            itemStyle: {        //上方显示数值
                normal: {
                    label: {
                        show: true, //开启显示
                        position: 'top', //在上方显示
                        textStyle: { //数值样式
                            color: 'black',
                            fontSize: 16
                        }
                    }
                }
            }
          }],
          tooltip: { // 鼠标悬浮提示框显示 X和Y 轴数据
     trigger: 'axis',
     backgroundColor: 'rgba(32, 33, 36,.7)',
     borderColor: 'rgba(32, 33, 36,0.20)',
     borderWidth: 1,
     textStyle: { // 文字提示样式
       color: '#fff',
       fontSize: '12'
     },
     axisPointer: { // 坐标轴虚线
       type: 'cross',
       label: {
           backgroundColor: '#6a7985'
       }
     },
   }
      };
      const myChart = echarts.init(document.getElementById("mychart"));
      myChart.setOption(option);
      window.addEventListener("resize", () => {
        myChart.resize();
      });
    },
  }
}
</script>

<style>
.inie-fia{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  border-bottom: 1px solid #ebeef5;
}
.inie-fia>span:nth-child(2)
{
  font-size: 20px;
}
.inie{
  display: flex;
  justify-content: space-between;
  padding: 20px;
  border-bottom: 1px solid #ebeef5;
}
.inie>span:nth-child(2)
{
  font-size: 20px;
}
.nav_third {
  color: rgba(0, 0, 0, 0.45);
}
.num_nav {
  color: rgba(0, 0, 0, 0.85);
  font-size: 30px;
  line-height: 38px;
  margin: 0;
}
.nav_border:after {
  background-color: #e8e8e8;
  position: absolute;
  top: 8px;
  right: 0;
  width: 1px;
  height: 40px;
  content: "";
}
.cont_navs_header_board {
  background-color: #fff;
  width: 100%;
  /* height: 55px; */
  box-sizing: border-box;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 20px;
  padding-left: 20px;
  align-items: center;
  padding-top: 20px;
  padding-bottom: 20px;
}
.bread {
  margin-bottom: 16px;
}
.grid-content {
  position: relative;
  padding: 26px 30px 0 35px;
  min-height: 140px;
  background-color: #ed5565;
}
.grid_center_info {
  color: #ffff;
}
.grid-content::after {
  position: absolute;
  right: 7px;
  content: "\e65d";
  bottom: 0px;
  font-family: icon_web !important;
}
.bot-content {
  position: relative;
}
.grid_center_info h5 {
  color: #fff;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1;
  margin: 0 0 5px 0;
}
.count {
  display: block;
  color: #fff;
  font: normal 46px/1 Arial, sans-serif;
  margin: 0 0 13px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.tips {
  font-size: 1rem;
  line-height: 1;
  margin: 0;
}

.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.time {
  font-size: 13px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
}

.button {
  padding: 0;
  float: right;
}
.image_ac{
  width: 100%;
  display: block;
  height: 125px;
}
.image {
  width: 100%;
  display: block;
  height: 160px;
}
.quick_a {
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  margin-bottom: -10px;
  margin-top: -10px;
}
.quick_a > button {
  flex-basis: 20%;
  cursor: pointer;
  margin-top: 10px;
}
.quick_a > a:hover {
  background: rgb(255, 255, 255);
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard.vue